import React from "react";
import ServicePackageDetailComponent from "@components/User/Package/PackageDetail/ServicePackageDetail";

export default function ServicePackageDetail() {
  return <ServicePackageDetailComponent />;
}
